var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-header-button"},[_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }